import CompaniesSidebar from './CompaniesSidebar'

export default CompaniesSidebar
